import type { ReactNode } from 'react'

export interface HighlightSegment {
  text: string
  matched: boolean
}

export function splitHighlightMatches(text: string, query: string): HighlightSegment[] {
  const trimmedQuery = query.trim()
  if (!trimmedQuery) return [{ text, matched: false }]

  const escaped = trimmedQuery.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
  const parts = text.split(new RegExp(`(${escaped})`, 'gi')).filter((part) => part.length > 0)

  return parts.map((part) => ({
    text: part,
    matched: part.toLowerCase() === trimmedQuery.toLowerCase(),
  }))
}

const DEFAULT_MATCH_CLASS_NAME = 'font-semibold text-foreground'

export function highlightMatch(
  text: string,
  query: string,
  matchClassName: string = DEFAULT_MATCH_CLASS_NAME
): ReactNode {
  const segments = splitHighlightMatches(text, query)
  if (segments.every((segment) => !segment.matched)) return text

  return segments.map((segment, index) =>
    segment.matched ? (
      <span key={index} className={matchClassName}>
        {segment.text}
      </span>
    ) : (
      segment.text
    )
  )
}
